import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PromiseResult, ErrorModel, ServerError } from '../../../../models/PromiseResult';
import { DoctorsService } from 'src/app/services/doctors.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Pending_Certificates } from 'src/app/models/certificates';
import { MessageService } from 'primeng';

@Component({
    selector: 'app-approve-certificate',
    templateUrl: './approve-certificate.component.html',
    styleUrls: ['./approve-certificate.component.css'],
    providers: []
})
export class ApproveCertificateComponent implements OnInit {
    pending_certificates: Pending_Certificates[] = [];
    response: PromiseResult;
    table_response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;
    base64url: string;

    constructor(private readonly doctorService: DoctorsService,
        private readonly messageService: MessageService
    ) { }

    ngOnInit() {
        this.getPendingCertificates();
    }

    async getPendingCertificates() {
        await this.doctorService.GetPendingCertificates().toPromise().then(async result => {
            this.table_response = result;
            if (this.table_response.success) {
                let temp: Pending_Certificates[] = []

                for (let i = 0; i < result.data.rows.length; i++) {
                    temp.push({
                        id: result.data.rows[i].id,
                        document_name: result.data.rows[i].document_name,
                        document_url: result.data.rows[i].document_url,
                        expires_on: result.data.rows[i].expires_on,
                        verified_by: result.data.rows[i].verified_by == null ? 'Not verified' : result.data.rows[i].verified_by,
                        d_email: result.data.rows[i].egd_users.d_email,
                        doctor_name: result.data.rows[i].egd_users.first_name + ' ' + result.data.rows[i].egd_users.last_name,
                        doctor_user_guid: result.data.rows[i].doctor_user_guid
                    });
                }

                this.pending_certificates = temp;
            }
        })
    }

    async DownloadCertificate(certificate_id: string, doctor_user_guid: string) {
        await this.doctorService.DownloadDoctorCertificate(certificate_id, doctor_user_guid).toPromise().then(async result => {
            this.table_response = result;
            if (this.table_response.success) {
                this.base64url = this.table_response.data.base64;
                const downloadLink = document.createElement('a');
                const fileName = 'certificate.pdf';

                downloadLink.href = this.base64url;
                downloadLink.download = fileName;
                downloadLink.click();
            }
        })
    }

    async ApproveCerificate(certificate_id: string) {
        await this.doctorService.VerifyDoctorCertificate(certificate_id).toPromise().then(async result => {

            console.log(result, "cgeee");
            if (result.success) {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Certificate Approved Successfully",
                });
                this.getPendingCertificates();
            }
            else if (!result.success) {
                this.posting = false;
                this.error = result.error;
            }
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.posting = false;
        });
    }
}
